import { cn } from "@/libs/utils";
import { ReactNode } from "react";

type Props = {
  variants?: "default";
  label: string;
  className?: string;
  onClick?: () => void;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

export default function CommonButton({
  variants = "default",
  label,
  className,
  onClick,
  iconLeft,
  iconRight,
}: Props) {
  return (
    <button
      className={cn(
        {
          "bg-dark-brown rounded-[4px] px-[23px] py-[8px] text-white font-bold text-[10px] flex items-center gap-1":
            variants === "default",
        },
        className
      )}
      onClick={() => onClick?.()}
    >
      {iconLeft && <span className="icon-left">{iconLeft}</span>}
      {label}
      {iconRight && <span className="icon-right">{iconRight}</span>}
    </button>
  );
}
